import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-invalid-session',
    templateUrl: './invalid-session.component.html',
    standalone: false
})
export class InvalidSessionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void { }

}
